import styled from '@emotion/styled';
const STYLES = {
    small: {
        gap: '2px'
    },
    regular: {
        gap: '4px'
    },
    large: {
        gap: '6px'
    },
};
export const Wrapper = styled.div `
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	${({ size }) => STYLES[size]};
`;
//# sourceMappingURL=StarRating.styled.js.map